import CostModal from './CostModal.vue';

export default CostModal;
